import { useSelector } from 'react-redux';
import { getCurrentDropTarget, getDragItemIsHidden, makeGetEmptyGridContainers, makeGetIsGridLayoutTreeEmpty } from '../../redux/selectors/layoutSectionDndSelectors';
import GridEmptyContainerPlaceholder from '../../components/GridEmptyContainerPlaceholder';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
import GridEmptyTreePlaceholder from '../../components/GridEmptyTreePlaceholder';
import { getActiveBreakpointName } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function GridLayoutEmptyPlaceholderContainer({
  gridLayoutId
}) {
  const activeBreakpointName = useSelector(getActiveBreakpointName);
  const currentDropTarget = useSelector(state => getCurrentDropTarget(state));
  const dragItemIsHidden = useSelector(state => getDragItemIsHidden(state));
  const getEmptyGridContainers = makeGetEmptyGridContainers();
  const emptyContainers = useSelector(state => getEmptyGridContainers(state, gridLayoutId)).filter(container => !container.isPegboard(activeBreakpointName));
  const getIsGridLayoutTreeEmpty = makeGetIsGridLayoutTreeEmpty();
  const isGridLayoutTreeEmpty = useSelector(state => getIsGridLayoutTreeEmpty(state, gridLayoutId));
  return /*#__PURE__*/_jsxs("div", {
    className: "grid-layout-empty-placeholder-container",
    children: [isGridLayoutTreeEmpty && /*#__PURE__*/_jsx(GridEmptyTreePlaceholder, {
      gridLayoutId: gridLayoutId
    }), emptyContainers.map(container => {
      const isHovered = !!currentDropTarget && !dragItemIsHidden && getImmutableOrPlain(currentDropTarget, 'containerId') === container.getId();
      return /*#__PURE__*/_jsx(GridEmptyContainerPlaceholder, {
        container: container,
        isHovered: isHovered
      }, container.getId());
    })]
  });
}